import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RelatiesService } from './shared/dataservices/relaties.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  title = 'relord 2020';



  constructor(private relatieService: RelatiesService) {
  }

  ngOnInit() {
    this.relatieService.getBranches().subscribe(data => {
      if (data.message) {
        alert(data.message);
      }
    })
   }



}

